import React from "react";

const CancelLink = ({onCancel}) => (
    <a className={"small"} onClick={onCancel}>or Cancel</a>
);

export default CancelLink;